<template>
  <rpm-input
    type="file"
    name="file"
    class="w-full"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    :accept-array="question.mimes"
    :file-limit="question.max"
    :multiple="question.min > 1 || question.max > 1"
    :url="`/api/v1/questions/${question.id}/upload`"
    :maxFileSize="question.max * 1024 ** 2"
    @uploaded="uploaded"
    v-model="question.value"
  ></rpm-input>
</template>

<script>
export default {
  name: "FileAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
  methods:{
    uploaded(response){
      this.question.value = response;
      this.$emit('updateQuestion', this.question);
      this.$emit('updateDetail', response);
    }
  }
};
</script>
